import { ViewMode } from '@playbooks/action-cards-utils/src'
import { cn } from '@playbooks/ui/lib/utils'
import Head from './Head'
import Footer from './Footer'
import { useAppContext } from '../contexts/AppContext'
import getSectionsSet from '../utils/getSectionsSet'

import useActionCardsApiRegister, { ActionCardsElement } from '../hooks/useActionCardsApiRegister'
import useSlideWidthAdjustment from '../hooks/useSlideWidthAdjustment'
import useAccentColorUpdate from '../hooks/useAccentColorUpdate'
import NoSectionsAlert from './NoSectionsAlert'
import ActionCardsSections from './ActionCardsSections'
import useMountEffect from '../hooks/useMountEffect'
import tryToPlayFirstVideo from '../utils/tryToPlayFirstVideo'

interface ActionCardsProps {
  ref?: React.Ref<ActionCardsElement | null>
}

export default function ActionCards({ ref }: ActionCardsProps) {
  const { data, rootRef, settings } = useAppContext()

  const { scopes, visiblePinnedSections, slides } = getSectionsSet({
    actionCards: data,
    headersCount: settings?.headers,
    hideSeparatorsAbility: settings?.hideSeparatorsAbility ?? true,
    viewMode: settings?.viewMode,
  })

  useActionCardsApiRegister(ref, slides)
  useAccentColorUpdate()
  useSlideWidthAdjustment()

  useMountEffect(() => {
    if (!rootRef.current || !settings.isWebplay || settings?.viewMode === ViewMode.FUNNEL) {
      return
    }
    tryToPlayFirstVideo(rootRef.current)
  })

  return (
    <div
      ref={rootRef}
      data-view={settings.viewMode || ViewMode.DEFAULT}
      data-role="action-cards-app"
      className={cn(
        'relative group/app flex flex-col h-full w-full bg-background text-foreground',
        'group-data-[view=funnel]:w-auto',
      )}
    >
      <Head />

      {scopes.length === 0 ? (
        <NoSectionsAlert />
      ) : (
        <ActionCardsSections
          hideScore={!!settings.hideScore}
          splitViewPosition={settings.splitViewPosition || 'left'}
          viewMode={settings.viewMode}
          isSplitViewEnabled={settings.isSplitViewEnabled}
          visiblePinnedSections={visiblePinnedSections}
          scopes={scopes}
          lastSlideHtml={settings.lastSlideHtml}
        />
      )}

      <Footer />
    </div>
  )
}
